var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaBilanzierungEinUndAusfuhr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#eff2fa;}.cls-3{fill:#c7cfe2;}.cls-4{fill:#89c8f5;}.cls-5{fill:#309eed;}.cls-6{fill:#59667c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.78,8H23.21a4.49,4.49,0,0,0-4,6.49L31.57,39.65V95.47a4.51,4.51,0,0,0,4.5,4.5H136.78a4.5,4.5,0,0,0,4.5-4.5v-83A4.49,4.49,0,0,0,136.78,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.78,8H115.27a4.49,4.49,0,0,1,4.5,4.5v83a4.5,4.5,0,0,1-4.5,4.5h21.51a4.5,4.5,0,0,0,4.5-4.5v-83A4.49,4.49,0,0,0,136.78,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.79,95.47H31.57v29.08A27.48,27.48,0,0,0,59,152h54.82a27.47,27.47,0,0,0,27.44-27.45V95.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.79,95.47h-17v29.08A27.48,27.48,0,0,1,92.32,152h21.52a27.47,27.47,0,0,0,27.44-27.45V95.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.07,48.5H31.57v9h22.5a4.5,4.5,0,0,0,0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.47,65.6h-9.9v9h9.9a4.5,4.5,0,0,0,0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.07,82.7H31.57v9h22.5a4.5,4.5,0,1,0,0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.07,116.9H31.57v9h22.5a4.5,4.5,0,0,0,0-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.47,99.8h-9.9v9h9.9a4.5,4.5,0,0,0,0-9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaBilanzierungEinUndAusfuhr);
export default __webpack_public_path__ + "static/media/ka_bilanzierung_ein_und_ausfuhr.1b19c26dafd0b8613f2c5b8973c3a883.svg";
export { ForwardRef as ReactComponent };